import { resetData, setData } from "./Utils";
import { EjariProperty } from "@eres/ejari-api/Entity";
import { getAppServices } from "@10x/coreapp";
import { HTRequestType } from "./api/entities";
import { isEmailVerified } from "@my-dld/utils/User";
import { showUnverifiedEmailError } from "@my-dld/utils/UIUtils";

export function showHandTakeOver( property: EjariProperty, type: HTRequestType ) {
	resetData();
	setData( property, type );
	const path = ( type === HTRequestType.HANDOVER ) ? "handover_form" : "takeover_form";
	getAppServices().navigationService.navigate( `/mydld/hand_take_over/${ path }` );
}

export function showRequestMain() {
	getAppServices().navigationService.navigate( "/mydld/hand_take_over/requests" );
}

export function showRequests( role: string ) {
	getAppServices().navigationService.navigate( `/mydld/hand_take_over/requests/${ role }` );
}

export function showRequestDetails( roleId: number, reqType: number, reqNo: string ) {
	getAppServices().navigationService.navigate( `/mydld/hand_take_over/request/${ roleId }/${ reqType }/${ reqNo }` );
}

export function showRequestRejection( reqNo: string ) {
	getAppServices().navigationService.navigate( `/mydld/hand_take_over/request/reject/${ reqNo }` );
}

export function editPropertyHandTakeOver( type: HTRequestType ) {
	if ( isEmailVerified() ) {
		const path = ( type === HTRequestType.HANDOVER ) ? "handover_form" : "takeover_form";
		getAppServices().navigationService.navigate( `/mydld/hand_take_over/${ path }` );
	} else {
		showUnverifiedEmailError();
	}
}
